import { StyleSheet } from 'react-native';
import { tokens } from '../design-system/tokens';

export const styles = StyleSheet.create({
  container: {
    width: '100%',
    // Pin the composer to its intrinsic height so the flex-column
    // chat surface can't shrink it away. The sibling ScrollView (the
    // message list) is `flex-1 min-h-0` — without `flexShrink: 0`
    // here, RN-Web's default `flex-shrink: 1` lets the composer
    // collapse to 0px when the chat surface's height is constrained
    // by its parent (AppShell main card with `overflow-hidden`),
    // which presents as "the composer is hidden at the bottom".
    flexShrink: 0,
  },
  replyToContainer: {
    paddingHorizontal: tokens.spacing.lg,
    paddingVertical: tokens.spacing.sm,
    flexDirection: 'row',
    alignItems: 'center',
    borderLeftWidth: 3,
    gap: tokens.spacing.sm,
  },
  replyToContent: {
    flex: 1,
  },
  replyToLabel: {
    fontSize: tokens.typography.fontSize.caption,
    fontWeight: `${tokens.typography.fontWeight.semibold}` as any,
    marginBottom: tokens.spacing.xxs,
  },
  replyToText: {
    fontSize: tokens.typography.fontSize.body,
    fontWeight: `${tokens.typography.fontWeight.regular}` as any,
  },
  cancelReplyButton: {
    padding: tokens.spacing.xs,
  },
  cancelReplyText: {
    fontSize: tokens.typography.fontSize.title,
    fontWeight: `${tokens.typography.fontWeight.regular}` as any,
  },
  inputContainer: {
    flexDirection: 'row',
    paddingHorizontal: tokens.spacing.lg,
    paddingVertical: tokens.spacing.md,
    borderTopWidth: 1,
    gap: tokens.spacing.sm,
    alignItems: 'flex-end',
  },
  input: {
    flex: 1,
    fontSize: tokens.typography.fontSize.body,
    fontWeight: `${tokens.typography.fontWeight.regular}` as any,
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.sm,
    borderRadius: tokens.radius.lg,
    maxHeight: 120,
    minHeight: 40,
  },
  sendButton: {
    paddingHorizontal: tokens.spacing.lg,
    paddingVertical: tokens.spacing.sm,
    borderRadius: tokens.radius.lg,
    minHeight: 40,
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 60,
  },
  sendButtonText: {
    fontSize: tokens.typography.fontSize.body,
    fontWeight: `${tokens.typography.fontWeight.semibold}` as any,
  },
});
